import { NewPeriodSelectorIntervalType } from 'src/app/core/enums/newPeriodSelectorIntervalType';
import { NewPeriodSelectorItem } from './new-period-selector-item';

export class NewCalendarPeriodSelectorItem extends NewPeriodSelectorItem {
  intervalType = NewPeriodSelectorIntervalType.Calendar;
  constructor(name: string) {
    super(name);
  }
}
